import type { WidgetDefinition } from "@nexus/widget-sdk";
import { manifest, Component, defaultConfig } from ".";
import { settings } from "./settings";

export const definition: WidgetDefinition = {
  id: "stacked-category-bars",
  module: { manifest, Component, defaultConfig },
  catalog: {
    description:
      "Monthly counts stacked by category, for one tenant or all the tenants of the report. Categories can differ between tenants and over time.",
    domain: "network-id",
    visual: "Stacked bars",
    purposes: ["reporting"],
    audiences: ["analyst", "client"],
  },
  layout: { kind: "chart", skeletonMinHeight: "26rem" },
  settings,
  defaultLayoutClassName: "col-span-12",
};
